import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
const BreadCrumbs = (props) => {
  const { crumb1, crumb2, crumbLink1 } = props;
  const navigate = useNavigate();

  return (
    <div className="flex flex-row items-center">
      <div
        onClick={() => navigate(-1)}
        className="bg-white rounded-full w-[40px] h-[40px] flex items-center justify-center hover:cursor-pointer hover:bg-[#1E293B] hover:text-white"
      >
        <IoMdArrowBack className="text-[22px]" />
      </div>
      <div className="flex items-center gap-x-1 font-bold text-base !text-gray-500 ml-[20px]">
        <Link
          className="text-md text-gray-500 font-medium hover:cursor-pointer hover:text-[#1E293B]"
          to={"/dashboard"}
        >
          Home
        </Link>
        <p className="text-md text-gray-500 font-medium">/</p>
        <p
          className="text-md text-gray-500 font-medium hover:cursor-pointer hover:text-[#1E293B]"
          onClick={() => navigate(-1)}
        >
          {crumb1}
        </p>
        {crumb2 !== "" && (
          <>
            <p className="text-md text-gray-500 font-medium">/</p>
            <Link className="text-md text-[#1E293B] font-bold hover:cursor-pointer">
              {crumb2}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default BreadCrumbs;
